module.exports = {"620923100":"党城湾镇","620923101":"马鬃山镇","620923201":"盐池湾乡","620923202":"石包城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620923.json
// module id = 2722
// module chunks = 0